import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';
import { CorreoPage } from '../correo/correo';

@IonicPage()
@Component({
  selector: 'page-new',
  templateUrl: 'new.html',
})
export class NewPage {

  para;
  asunto;
  mensaje;
  user;
  lect;
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http) {
    this.user = JSON.parse(localStorage.getItem("user"));

    if(navParams.get('estado') == 'respuesta'){
      this.lect = navParams.get('lectura');
      this.asunto = 'RE: ' + this.lect.ASUNTO;
      this.para = this.lect.CODIGO_EMI;
    }
    
    
  }

  enviar() {
    this.http.get('http://ebenlovequickpc.com/API/correo.php?cl=insert&desde='+this.user.CODIGO_USER+'&para='+this.para+'&asunto='+this.asunto+'&mensaje='+this.mensaje).subscribe((data)=>{
    this.navCtrl.setRoot(CorreoPage);
    })
  }

  atras(){
    this.navCtrl.setRoot(CorreoPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/new/new.ts